import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/discountschema';
const find = () => {
	return Client.get('/admin/api/profile-payment');
};

const update = (payload) => {
	return Client.put('/admin/api/profile-payment', payload);
};

const getSysParam = (code) => {
	return Client.get(`/admin/api/parameter/${code}`);
};
const getSysParamCloud = (merchantId, branchId, code) => {
	return Client.get(
		`/gateway/numbat-api/api/vs/manage-config/sysParameter/${merchantId}/${branchId}/get/${code}`
	);
};

const putSysParam = (code, data) => {
	return Client.put(`/admin/api/parameter/${code}`, data);
};
const putSysParamCloud = (merchantId, branchId, code, data) => {
	return Client.put(
		`/gateway/numbat-api/api/vs/manage-config/sysParameter/${merchantId}/${branchId}/sysParameter/${code}`,
		data
	);
};
const getDiscountschemaAll = () => {
	return Client.get(`/admin/api/discountschema`);
};
const getDiscountschemaAllCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}`);
};
const postDiscountschema = (data) => {
	return Client.post(`/admin/api/discountschema`, data);
};
const postDiscountschemaCloud = (merchantId, branchId, data) => {
	return Client.post(`${numbatUrl}/${merchantId}/${branchId}`, data);
};
const putDiscountschema = (code, data, params) => {
	return Client.put(`/admin/api/discountschema/${code}`, data, params);
};

const putDiscountschemaCloud = (merchantId, branchId, code, data, params) => {
	return Client.put(
		`${numbatUrl}/${merchantId}/${branchId}/${code}`,
		data,
		params
	);
};

const delDiscountschema = (code) => {
	return Client.del(`/admin/api/discountschema/${code}`);
};
const delDiscountschemaCloud = (merchantId, branchId, code) => {
	return Client.del(`${numbatUrl}/${merchantId}/${branchId}/${code}`);
};

export default {
	find,
	update,
	getSysParam,
	putSysParam,
	getDiscountschemaAll,
	postDiscountschema,
	putDiscountschema,
	delDiscountschema,
	getDiscountschemaAllCloud,
	getSysParamCloud,
	postDiscountschemaCloud,
	putDiscountschemaCloud,
	delDiscountschemaCloud,
	putSysParamCloud,
};
